import { useState, useEffect } from 'react'
import { getLinkPreview } from 'link-preview-js'

// Custom hook to fetch link preview
const useLinkPreview = url => {
  const [preview, setPreview] = useState(null)
  const [loadingLink, setLoadingLink] = useState(false)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!url) return

    const fetchPreview = async () => {
      setLoadingLink(true)
      try {
        const data = await getLinkPreview(url)
        setPreview(data)
      } catch (err) {
        setError(err)
        console.error('Error fetching link preview:', err)
      } finally {
        setLoadingLink(false)
      }
    }

    fetchPreview()
  }, [url])

  return { preview, loadingLink, error }
}

export default useLinkPreview
